import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Color } from 'chart.js';

@Component({
    selector: 'app-doughnut-chart-data-visualization-label',
    templateUrl: './doughnut-chart-data-visualization-label.component.html',
    styleUrls: ['./doughnut-chart-data-visualization-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class DoughnutChartDataVisualizationLabelComponent {

    @Input({ required: true }) color!: Color;

    @Input({ required: true }) label!: string;
}
